
import { Component, EventEmitter, Input, Output , OnInit, OnChanges} from '@angular/core';


@Component({
  selector: 'app-geoposicionar',
  templateUrl: './geoposicionar.component.html',
  styleUrls: ['./geoposicionar.component.scss']
})


export class GeoposicionarComponent implements OnInit, OnChanges {

	ngOnInit(): void {
	}

	ngOnChanges(change){

	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/geoposicionamiento/geoposicionar.component.ts